<template>
  <div>
    <v-dialog v-model="dialog" width="75%">
      <v-card>
        <v-card-title class="mx-3">
          <span class="headline">{{
            $t("MovePositionOrder.StockBatchDialog.title")
          }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense align="center">
              <v-col cols="12" sm="5" md="6">
                <SearcherKeyword
                  :label="
                    $t(
                      'MovePositionOrder.StockBatchDialog.stockBatchCodeSearch'
                    )
                  "
                  v-model="seacherStockBatchCodeKeyword"
                  @text="KeyWord = $event"
                />
              </v-col>
              <v-col cols="12" sm="5" md="4">
                <!-- 状态 -->
                <SearcherStatus
                  v-model="stockBatchStatus"
                  :items="$consts.expiredFlgs"
                  :label="
                    $t(
                      'MovePositionOrder.StockBatchDialog.stockBatchStatusSearch'
                    )
                  "
                />
              </v-col>
              <v-col cols="12" sm="2" align-self="center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      text
                      class="caption font-weight-bold grey--text"
                      color="primary"
                      @click.stop="onSearch()"
                    >
                      <v-icon small class="pe-1">fa-search</v-icon>
                      {{ $t("Search.search") }}
                    </v-btn>
                  </template>
                  <span>{{ $t("Search.searchTip") }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-data-table
              :headers="stockBatchHeaders"
              :items="positionBatchs"
              :loading="loading"
              multi-sort
              disable-pagination
              hide-default-footer
              class="elevation-0 px-6"
              fixed-header
              height="360px"
            >
              <template v-slot:item.material_description="{ item }">
                {{
                  $t(
                    settings
                      ? settings.material_name_display_type == 4
                        ? "Material.nameWithCodeAndStandard"
                        : settings.material_name_display_type == 3
                        ? "Material.materialNameWithCodeAndStandard"
                        : settings.material_name_display_type == 2
                        ? "Material.materialNameWithCode"
                        : "Material.materialName"
                      : "Material.materialName",
                    [
                      item.material.material_code,
                      item.material.material_name,
                      item.material.standard.name,
                    ]
                  )
                }}
              </template>
              <template v-slot:item.position_description="{ item }">
                {{
                  $t("MovePositionOrder.DetailFields.position", [
                    item.position_code,
                    item.position_name,
                  ])
                }}
              </template>
              <template v-slot:item.stock_batch_code="{ item }">
                {{ item.stock_batch_code }}
                <v-chip
                  v-if="item.expired_flg"
                  x-small
                  label
                  :color="item.expired_flg | expiredFlgsColor"
                  :text-color="item.expired_flg | expiredFlgsTextColor"
                >
                  {{ item.expired_flg | expiredFlgsText }}
                </v-chip>

                <v-chip
                  v-if="item.prohibit_flg"
                  x-small
                  label
                  :color="item.prohibit_flg | prohibitFlgsColor"
                  :text-color="item.prohibit_flg | prohibitFlgsTextColor"
                >
                  {{ item.prohibit_flg | prohibitFlgsText }}
                </v-chip>
              </template>
              <template v-slot:item.production_date="{ item }">
                {{ item.production_date | formatDate }}
              </template>
              <template v-slot:item.expired_date="{ item }">
                {{ item.expired_date | formatDate }}
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="dialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import MovePositionOrders from "@/api/move_position_orders";

export default {
  name: "ShowMaterialPositionBatchDialog",

  props: {
    value: Boolean,
    label: String,
    materialPositiobDetail: Object,
  },

  components: {
    SearcherKeyword,
    SearcherStatus,
  },

  computed: {
    //搜索
    positionBatchs() {
      //前端搜索
      return this.stock_material_position_batchs.filter(
        (item) =>
          ((this.stockBatchStatus.length &&
            this.stockBatchStatus.find((flg) => flg == item.expired_flg) !=
              undefined) ||
            !this.stockBatchStatus.length) &&
          ((this.seacherStockBatchCodeKeyword &&
            item.stock_batch_code.indexOf(this.seacherStockBatchCodeKeyword) >
              -1) ||
            !this.seacherStockBatchCodeKeyword)
      );
    },

    stockBatchHeaders() {
      return [
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.material"
          ),
          align: "center",
          sortable: false,
          value: "material_description",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.position"
          ),
          align: "center",
          sortable: false,
          value: "position_description",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.stock_batch_code"
          ),
          align: "center",
          sortable: false,
          value: "stock_batch_code",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.production_date"
          ),
          align: "center",
          sortable: false,
          value: "production_date",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.expired_date"
          ),
          align: "center",
          sortable: false,
          value: "expired_date",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser"]),
  },
  methods: {
    onSearch() {
      this.seacherStockBatchCodeKeyword = this.KeyWord;
    },
  },

  data: () => ({
    dialog: false,
    stock_material_position_batchs: [],
    seacherStockBatchCodeKeyword: "",
    stockBatchStatus: [0, 1],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.stock_material_position_batchs = [];
        }
      },
    },
    materialPositiobDetail: {
      handler() {
        MovePositionOrders.getMaterialPositionBatch({
          material_id: this.materialPositiobDetail.material_id,
          position_id: this.materialPositiobDetail.stock_position_id,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stock_material_position_batchs =
                response.data.stock_material_positions;

              this.stock_material_position_batchs.forEach((batch) => {
                if (
                  new Date(batch.expired_date).getTime() < new Date().getTime()
                ) {
                  batch.expired_flg = 1;
                } else {
                  batch.expired_flg = 0;
                }
              });
            }
          }.bind(this)
        );
      },
    },
  },
};
</script>